// eslint-disable-next-line no-empty-pattern
export function TournamentSeriesCalculatedStandings({}: { seriesId: string }) {
    // For now, just show a placeholder message
    // The calculated standings are working in the mobile app but need more work for CMS

    return (
        <div className="my-4 w-full">
            <h3 className="mb-4 text-lg font-bold">Calculated Standings</h3>
            <div className="rounded-md border bg-gray-50 p-8 text-center">
                <p className="mb-2 text-gray-600">
                    Standings are calculated automatically based on tournament results.
                </p>
                <p className="text-sm text-gray-500">
                    View the calculated standings in the mobile app.
                </p>
            </div>
        </div>
    );
}
